import React from "react";

export default function Footer(){
  return (
      <footer className="footer flex-center cf-none-mob">
          <p>@2024 - Cổng Thanh Toán LOTTE C&amp;F</p>
          <ul className="cf-unorderlist cf-right">
              <li>Thời gian hỗ trợ: 9h00 – 22h00</li>
              <li>Email: <a href="mailto:info@lottecnf.com">info@lottecnf.com</a></li>
          </ul>
      </footer>
  );
};
